<template>
  <div id="app">
    <div v-if="newPage">
      <router-view></router-view>
    </div>
    <div v-else-if="valid" class="main">
      <new-nav v-if="isNew2 ?? isNew"></new-nav>
      <navs v-else></navs>
      <div class="content">
        <new-com-head></new-com-head>
        <div style="padding: 8px; min-width: 900px; box-sizing: border-box; flex: 1; overflow: auto">
          <router-view> </router-view>
        </div>
      </div>
      <newCustomerService @show="visible = true" />
    </div>
    <div v-else-if="['jump', 'administrator', 'admin'].includes(this.$route.name)">
      <router-view></router-view>
    </div>
    <div v-else class="login">
      <el-empty class="empty" description="暂无此页面" style="margin: 200px auto"></el-empty>
    </div>
  </div>
</template>
<script>
import { frontRoutes } from '@/project/router/modules/front.js';
import { adminRoutes } from '@/router/admin.js';
export default {
  name: 'App',
  data() {
    return {
      visible: false,
      isNew2: null,
    };
  },
  computed: {
    isNew() {
      return sessionStorage.getItem('newVersion') == 1 ? true : false;
    },
    newPage() {
      return (
        (adminRoutes && adminRoutes.some((route) => route.name == this.$route.name)) ||
        this.$route.path.includes('/admin/login') ||
        (frontRoutes && frontRoutes.some((route) => route.name == this.$route.name))
      );
    },
    valid() {
      console.log(this.$route.name, 7987897);
      return this.$route.name && this.$route.name !== 'jump' && this.$route.name !== 'administrator';
    },
  },
  created() {
    this.$bus.$on('setNew', (res) => {
      this.isNew2 = res;
    });
  },
  methods: {},
  components: {},
};
</script>
<style lang="less">
@import './css/index.less';
@import './css/reset.less';
</style>
<style lang="less">
html,
body {
  margin: 0;
  width: 100%;
  height: 100%;
  min-width: 1920px;
  overflow-x: auto;
}

#app {
  background: #e7effd;
  height: 100vh;
  overflow-y: hidden;
}

.top-uni {
  height: 80px;
}

.main {
  display: flex;
  height: 100%;

  .content {
    flex: 1;
    min-width: 1100px;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .menu {
    color: white;
    height: 100vh;
    width: 257px;
  }

  /deep/.el-message {
    z-index: 10000000;
    /* 设置z-index为10000，可以根据需求自行调整 */
  }

  .el-menu-vertical-demo {
    width: 240px;
    height: 89.4vh;
    overflow: auto;
    border: none;
  }

  .el-menu-vertical-demo {
    ::-webkit-scrollbar {
      // background-color: #000;  版本1滚动条颜色
      background-color: #0b2f59;
    }

    ::-webkit-scrollbar-track {
      background-color: #7dc2f6;
    }

    ::-webkit-scrollbar-button {
      background-color: #b9e0fd;
    }

    ::-webkit-scrollbar-corner {
      background-color: #018ef8;
    }
  }

  .el-menu-vertical-demo::-webkit-scrollbar-track {
    // background-color: #333;  版本1滚动条颜色
    background-color: #0b2f59;
  }

  .el-menu-vertical-demo::-webkit-scrollbar-thumb {
    // background-color: #0B2F59; 版本1滚动条颜色
    background-color: #0b2f59;
    opacity: 0.5;
    border: none;
  }
}

.login {
  max-height: 100%;
  overflow-y: auto;
}
</style>
